/**
 * What an NPC's quest window has to show (D12, 2026-10-07): offered and
 * active quests plus featured teasers. An NPC whose only quest content is a
 * locked featured teaser still opens its quest window, showing the teaser.
 */

import type { NPC } from '../../../shared/NPCData';
import { NPC_CONFIG } from '../../../shared/content/generated/entities.gen';
import { QUEST_DATABASE } from '../../../shared/content/generated/quests.gen';
import { isQuestOffered } from '../../../shared/quests/questOffer';

/** Quests plus teasers the quest window would render for a hydrated NPC. */
export function npcQuestEntryCount(npc: Pick<NPC, 'quests' | 'featuredTeasers'>): number {
  return npc.quests.length + (npc.featuredTeasers?.length ?? 0);
}

/**
 * Whether the NPC authors a featured quest the server did not offer. Decided
 * from the server reply alone (no quest log), so it can over-report a teaser
 * for an already finished quest; the hydrated `npcQuestEntryCount` is the
 * gate that decides whether the window actually renders.
 */
export function mayHaveFeaturedTeaser(npcId: string, offeredQuestIds: readonly string[]): boolean {
  const offered = new Set(offeredQuestIds);
  return (NPC_CONFIG[npcId]?.availableQuests ?? [])
    .some(id => QUEST_DATABASE[id]?.featured && isQuestOffered(QUEST_DATABASE[id]) && !offered.has(id));
}
